import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-footer-with-bg',
  templateUrl: './footer-with-bg.component.html',
  styleUrls: ['./footer-with-bg.component.css']
})
export class FooterWithBgComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
